import React, { Component } from 'react'
import {connect} from 'react-redux';

import { Grid, AppBar, Toolbar, Menu, MenuItem } from '@material-ui/core';
import { SuperUserDropdown } from './SuperUserDropdown';

import LockIcon from "@material-ui/icons/Lock";

import { getAllCLCommunities, getCommunityById } from '../../actions/communityActions';
import { LogoutProccess } from '../../actions/authActions';

import logo from '../../assets/images/SentricsLogoPng.png'

class LegacyAppBar extends Component {
    constructor(props) {
        super(props);

        this.state = {
            open: false,
            actualCommunityId: undefined,
            //Community
            superUserCommunitySelected: undefined,
            superUserActivitiesLoaddedForCommunity: undefined,

        }

    };

    componentDidMount() {
        if (localStorage.getItem('superAdmin') === "false") {
            this.props.getCommunityById(localStorage.getItem('communityId'))
        }
        else {
            this.props.getAllCLCommunities()
        }
    }

    logout = () => {
        this.props.LogoutProccess();
    }


    setLocalState = (objectToSet) => {
        try {
            this.setState({ ...objectToSet });
        } catch (err) { }
    };

    localStorageRemoveItem = (key) => {
        try {
            if (key) {
                localStorage.removeItem(key);
            }

        } catch (err) { }
    };

    localStorageSetItem = (key, value) => {
        try {
            if (key && value) {
                this.setState({
                    open: false,
                    openCategory: false,
                    tab: 0,
                })
                localStorage.setItem(key, value);
            }

            if (value && value.length > 0) {
                this.props.dispatchActions();
            }
        } catch (err) { }
    };

    GetCommunityObjectForSupuerUserCombo(communityId) {
        let communityObj = null;
        if (this.props.communityData) {

            communityObj = this.props.communityData.find(item => item.communityId === communityId);
        }

        return communityObj;
    };

    ImageComponent = () => {

        const title = this.props.title? this.props.title : ''
        return (
            <Grid item container>
                <Grid item style={{ display: 'flex', alignItems: 'center' }}>
                    <img
                        src={logo}
                        alt="logo"
                        className="logoV2"
                    />
                </Grid>
                <Grid item className='LHeaderTitle' style={{ display: 'flex' }}>
                    <Grid>
                        {title}
                    </Grid>
                </Grid>
            </Grid>
        );
    };

    AvatarComponent = () => {
        const [anchorEl, setAnchorEl] = React.useState(null);
        const menuOpen = Boolean(anchorEl);

        const handleMenu = (event) => {
            setAnchorEl(event.currentTarget);
        };

        const handleClose = () => {
            setAnchorEl(null);
        };

        return (
            <Grid item style={{ display: 'flex', alignItems: 'center' }}>

                <Grid item className="InitialCMSV2" onClick={handleMenu}>
                    { 
                        `${this.props.givenName? this.props.givenName.slice().charAt(0).toUpperCase() : ''}${this.props.familyName? this.props.familyName.slice().charAt(0).toUpperCase():''}`
                    }
                </Grid>

                <Menu
                    id="menu-appbar"
                    anchorEl={anchorEl}
                    anchorOrigin={{
                        vertical: "top",
                        horizontal: "right",
                    }}
                    keepMounted
                    transformOrigin={{
                        vertical: "top",
                        horizontal: "right",
                    }}
                    open={menuOpen}
                    onClose={handleClose}
                >
                    <MenuItem onClick={this.logout} button >
                        <LockIcon className="btn-icon-nav text-medium" />{" "}
                        <span className="text-medium">Sign out</span>
                    </MenuItem>
                </Menu>

            </Grid>
        );
    }

    render() {
        const isSuperAdmin = localStorage.getItem('superAdmin') ? (localStorage.getItem('superAdmin') === "true") : false;

        if (isSuperAdmin
            && this.props?.communityData?.length > 0
            && localStorage.getItem('communityId')?.length > 0
            && this.state.superUserCommunitySelected === undefined
        ) {
            this.setState({ superUserCommunitySelected: this.GetCommunityObjectForSupuerUserCombo(localStorage.getItem('communityId')) });
        }


        return (
            <>
                <Grid item container style={{ height: '20%' }}>
                    <Grid item container style={{ height: '50%' }}>
                        <AppBar
                            id="legacyAppBar"
                            color="primary"
                            position="fixed"
                        >
                            <Toolbar className="makeStyles-toolbar">
                                <Grid container>
                                    {/* logo */}
                                    <Grid item container xs={6}>
                                        <this.ImageComponent />
                                    </Grid>
                                    {/* dropdown  */}
                                    <Grid item container xs={5} key={'dropdown'} justifyContent='flex-end' style={{ display: 'flex', alignItems: 'center' }}>
                                        {
                                            this.props.isSuperAdmin && this.props.superUserVisible ?
                                                <Grid item container xs={12} style={{ paddingLeft: '15px', marginRight: '15px' }} justifyContent='center' alignContent='center' >
                                                    <SuperUserDropdown
                                                        setState={this.setLocalState}
                                                        communityData={this.props.communityData}
                                                        superUserCommunitySelected={this.state.superUserCommunitySelected}
                                                        localStorageSetItem={this.localStorageSetItem}
                                                        localStorageRemoveItem={this.localStorageRemoveItem}
                                                    />
                                                </Grid>
                                                :
                                                undefined
                                        }
                                    </Grid>
                                    {/* avatar */}
                                    <Grid item container xs={1} justifyContent='flex-end' alignContent='center'>
                                        <this.AvatarComponent />
                                    </Grid>
                                </Grid>
                            </Toolbar>
                        </AppBar>

                    </Grid>
                    <Grid item container style={{ height: '50%' }} className='LHeaderButtons'></Grid>
                </Grid>
            </>
        )
    }
}

function mapStateToProps(state,dispatch) {
    const isSuperAdmin = (state.authReducer && state.authReducer.superAdmin) ? state.authReducer.superAdmin : undefined;
    const givenName = (state.authReducer && state.authReducer.givenName) ? state.authReducer.givenName : undefined;
    const familyName = (state.authReducer && state.authReducer.familyName) ? state.authReducer.familyName : undefined;
    let communityData = (state.communityReducer && state.communityReducer.communityData && Array.isArray(state.communityReducer.communityData) && state.communityReducer.communityData.length > 0) ? state.communityReducer.communityData.map(item => ({ _id: item._id, name: item.communityName, communityId: item.communityId })) : [];

    if (communityData) {
        communityData =
            communityData.map((item, index) => {
                item.indexForCombo = index;
                return item;
            })
    }

    return {
        isSuperAdmin: isSuperAdmin,
        givenName: givenName,
        familyName: familyName,
        communityData: communityData
    }
};

export default connect(mapStateToProps,{getAllCLCommunities, getCommunityById, LogoutProccess})(LegacyAppBar)
